export default "__VITE_ASSET__DAjRv0lV__"